import { DEFAULT_MULTIPLIER, SKIP_PAGES } from './constants';

export function getStorefrontApiToken(context = {}) {
    return context.storefrontApiToken || '';
}

export function parseNumber(value) {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? NaN : parsed;
}

export function formatEntries(value) {
    return Math.round(value).toLocaleString();
}

export function formatRounded(value) {
    return Math.round(value).toLocaleString();
}

export function formatMultiplier(value) {
    return `x${value} MULTIPLIER`;
}

export function parsePriceText(text) {
    const match = (text || '').replace(/,/g, '').match(/[\d]+(?:\.\d+)?/);
    return match ? parseNumber(match[0]) : NaN;
}

export function normalizeMultiplier() {
    return DEFAULT_MULTIPLIER;
}

export function isSkippedPage() {
    return SKIP_PAGES.some((cls) => document.body.classList.contains(cls));
}
